import {UserPermission} from '@interface/user-permission';
import {UserRole} from '@enum/user-roles/user-role';
import {UserPermissionManager} from './user-permission';
import {CrmSection} from '@enum/crm-section';
import {ProformaLabels} from '../proforma-cart-labels/proforma-labels';
import {OrderModalComponent} from '../../../components/order-modal/order-modal.component';

class TechDepPermissionClass implements UserPermission {
  readonly userRole = UserRole.TECH_DEP;
  readonly labelRole = 'Tech Dep';
  readonly isAuthenticated = true;

  readonly canRequestEto = false;
  readonly isDefaultUntaxedPrice = true;
  readonly canAlwaysGoToConfigurationSummary = false;

  readonly canModifyAllConfigurations = false;
  readonly canSeeConfigurationsPrice = true;

  readonly hasMoreClients = false;
  readonly canSeeHisAccountInRightDrawer = true;
  readonly canSeeHisAccountPreferences = true;
  readonly canHaveManyEditableProforma = false;
  readonly canModifyCountry = false;

  readonly canRegisterShopVendorFinalUser = false;
  readonly canSeeAlternativeExternalCustomersTab = false;
  readonly canSeeShopVendorList = false;
  readonly canChangeLogo = false;

  readonly canGoToUserArea = false;
  readonly crmSectionsVisible = [CrmSection.Claims];
  readonly isLabelRoleVisibleInHeader = false;

  readonly proformaCartLabels = ProformaLabels;

  readonly visibleInterCompanyDependentFields = [];
  readonly editableInterCompanyDependentFields = [];

  readonly visibleUserAreaFilters = [];
  readonly visibleUserAreaColumns = [];

  readonly orderViewModal = OrderModalComponent;

  readonly canAssignCrmTaskToOthers = true;
  readonly canSeeAssignedUserStats = false;

  readonly canSelfAssignClaims = true;
  readonly canEditClaimAnswer = true;
  readonly canOpenNewClaims = true;
  readonly canHandleAdvancedClaimInfo = true;

  readonly canGiveExpirationFeedback = false;
  readonly canDownloadPackingList = false;
  readonly canSeeConfigurationList = false;
  readonly canSeeCustomerConfigurationTab = false;
  readonly canSeeSummaryRecap = false;
  readonly canEditProbability = true;

  readonly composerAllowed = true;
}

const TechDepPermission = new TechDepPermissionClass();

UserPermissionManager.instance.assignPermissionForRole(TechDepPermission);
